<template>
  <Card
    class="koc-default-collection-item-discount"
    :image-link="FormattingService.formatUrl(item)"
    :image-url="state.imageUrl"
    :show-overlay="!state.hasAccess"
    :content-title="item.title"
    :content-link="FormattingService.formatUrl(item)"
    :content-body="item.excerpt"
    footer-text="Get Discount"
    :footer-link="FormattingService.formatUrl(item)"
  />
</template>

<script src="./discount.js"></script>
<style lang="scss" scoped src="./discount.scss"></style>
